import { render, staticRenderFns } from "./InvolvedVehicleForm.vue?vue&type=template&id=6272c1ea&"
import script from "./InvolvedVehicleForm.vue?vue&type=script&lang=js&"
export * from "./InvolvedVehicleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports